import {
    IPerfectScrollContext,
    IPerfectScrollState,
} from "../scroll/perfectScrollModel";
import {
    MutableRefObject,
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import { PerfectScrollContext } from "../scroll/perfectScrollContext";
import { equals, isObjectPropsEquals } from "../_utils/equality";
import { ICustomScrollSelector } from "./CustomScrollStoreModel";

/*
 */
export const useCustomScrollSelector = <T = any>(
    selector: ICustomScrollSelector<T>,
    customScrollContext: IPerfectScrollContext = null
): T => customScrollSelector<T>(selector, equals, customScrollContext);

/*
 */
export const useCustomScrollObjectSelector = <T = any>(
    selector: ICustomScrollSelector<T>,
    customScrollContext: IPerfectScrollContext = null
): T =>
    customScrollSelector<T>(selector, isObjectPropsEquals, customScrollContext);

/*
 */
function customScrollSelector<T = any>(
    selector: ICustomScrollSelector<T>,
    isEquals: (a: T, b: T) => boolean = (a, b) => a === b,
    customScrollContext: IPerfectScrollContext = null
): T {
    const { store } = customScrollContext ?? useContext(PerfectScrollContext);
    const [value, setValue] = useState<T>(null);
    const valueRef = useRef(value);
    valueRef.current = value;

    const tryUpdate = useCallback(
        () =>
            tryUpdateFn(selector, isEquals, store.getState, valueRef, setValue),
        []
    );

    useEffect(() => store.subscribe(tryUpdate), []);
    return selector(store.getState());
}

function tryUpdateFn<T>(
    selector: ICustomScrollSelector<T>,
    isEquals: (a: T, b: T) => boolean = (a, b) => a === b,
    getState: () => IPerfectScrollState,
    value: MutableRefObject<T>,
    setValue: (c: T) => void
) {
    const newValue = selector(getState());
    if (!isEquals(value.current, newValue)) setValue(newValue);
}
